import { Pipe, PipeTransform } from '@angular/core';
import { convertMd2Html } from './text.functions';

@Pipe({
  name: 'md2html'
})
export class Md2htmlPipe implements PipeTransform {

  transform(src: string): string {
    return convertMd2Html(src);
  }
}
